import { render } from "./OngoingUpcomingPD.vue?vue&type=template&id=352c9918"
import script from "./OngoingUpcomingPD.vue?vue&type=script&lang=js"
export * from "./OngoingUpcomingPD.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__